import React, { useEffect, useState } from 'react'
import {
    APIProvider, Map,
    Marker, InfoWindow
} from '@vis.gl/react-google-maps'
import { DraggableIcon, MapDeviceRemove, MapPinIcon, SearchIcon, SearchIconWhite } from '../../../../assets/images'
import { hasDecimalPoint } from '../../../../utils/utils';
import { GOOGLE_API_KEY } from '../../../../config';

// const API_KEY = process.env.REACT_APP_GOOGLE_MAP_API_KEY;
// const API_KEY = 'AIzaSyAzT-a38L6sTEKHtszlU2K3eiufuNuPTew'; // 1st One
// const API_KEY = 'AIzaSyCtfCedgP3TnN_IiJYRq5rVI2g8uC-JtwQ'; // 2nd One
// const API_KEY = 'AIzaSyDVxhzWPOgVHgDhYaFKBUQi8nP56zxMNhA'; // 3rd One

const API_KEY = GOOGLE_API_KEY

console.log("APIKEY", API_KEY)

let tempPos = {
    lat: 19.0747045, lng: 72.8869815   
    // lat: 19.2143377, lng: 73.1024171
}

const GoogleMap = React.memo(({ isDarkTheme, deviceList, setDeviceList, deviceMasterList, setDeviceMasterList, editForm, selectedZone, markerList, setMarkerList, selectedItem }) => {
    console.count("GoogleMap Render Count")
    const [searchTextDevice, setSearchTextDevice] = useState("")
    const [selectedMarker, setSelectedMarker] = useState(null);
    const [centerPos, setCenterPos] = useState(tempPos)
    const [count, setCount] = useState(0)

    //#region Map Functions

    useEffect(() => {
        if(selectedZone?.Lattitude){
            console.log("selectedZoneGoogleMap", selectedZone);
            let pos = {
                lat: selectedZone?.Lattitude,
                lng: selectedZone?.Longitude
            }
            let c = count + 1;
            setCount(c)
            setCenterPos(pos)
        }
    }, [selectedZone])

    const searchHandler = (text) => {
        setSearchTextDevice(text);
        let temp = deviceMasterList.filter((item) => item.Name.toLowerCase().includes(text.toLowerCase()))
        setDeviceList(temp);
    }

    const handleDragStartMap = (event, device) => {
        if(!editForm || selectedItem == "custom"){
            return
        }
        if(markerList?.find(item => item.DeviceId === device.DeviceId)){
            return;
        }
        event.dataTransfer.setData('device', JSON.stringify(device));
    };

    const handleDragOver = (event) => {
        event.preventDefault();
    };
    const handleMarkerDragEnd = (event, DeviceId) => {
        const newPosition = {
            lat: event.latLng.lat(),
            lng: event.latLng.lng(),
        };
        let temp = markerList.map((item) => {
            if (item.DeviceId == DeviceId) {
                return {
                    ...item,
                    position: newPosition,
                };
            } else {
                return item;
            }
        });
        // setMarkerPosition(newPosition);
        setMarkerList(temp);
        let tempArr = deviceMasterList.map((item) => {
            if (item.DeviceId == DeviceId) {
                return {
                    ...item,
                    isSelected: true,
                    isTouched: true,
                    Lat: newPosition.lat,
                    Long: newPosition.lng
                }
            } else {
                return {
                    ...item
                }
            }
        })
        setDeviceList(tempArr)
        setDeviceMasterList(tempArr)
    };

    const handleMapDrop = (event) => {
        event.preventDefault();
        const device = JSON.parse(event.dataTransfer.getData('device'));
        const mapBounds = event.currentTarget.getBoundingClientRect();
        // const latLng = {
        //     lat: 19.0747045, // Replace this with dynamic lat/lng conversion
        //     lng: 72.8869815, // You can use Google Maps' utilities or mock a conversion
        // };
        const latLng = {
            lat:selectedZone?.Lattitude, 
            lng:selectedZone?.Longitude
        }
        setMarkerList((prev) => [
            ...prev,
            { DeviceId: device.DeviceId, Name: device.Name, position: latLng },
        ]);
        let tempArr = deviceMasterList.map((item) => {
            if (item.DeviceId == device.DeviceId) {
                return {
                    ...item,
                    isSelected: true,
                    isTouched: true,
                    Lat: latLng.lat,
                    Long: latLng.lng
                }
            } else {
                return {
                    ...item
                }
            }
        })
        setDeviceList(tempArr)
        setDeviceMasterList(tempArr)
    };

    const removeMapMarker = (DeviceId) => {
        if(!editForm){
            return;
        }
        let tempArr = deviceMasterList.map((item) => {
            if (item.DeviceId == DeviceId) {
                return {
                    ...item,
                    isSelected: false,
                    isTouched: true,
                    Lat: 0.0,
                    Long: 0.0        
                }
            } else {
                return {
                    ...item
                }
            }
        })
        setDeviceList(tempArr)
        setDeviceMasterList(tempArr)
        let secondTempArr = markerList.filter((item) => item.DeviceId != DeviceId)
        setMarkerList(secondTempArr)
    }

    //#endregion

    return (
        <div className='mt-4 MapContainerFlex'>
            <div className='Map_List'>
                <div className="m-2 HeaderSiteList">
                    <input
                        id="Search_txt_site"
                        className="SearchViewInput1" style={{ width: "80%" }}
                        type="text"
                        value={searchTextDevice}
                        onChange={(e) => searchHandler(e.target.value)}
                        placeholder="Search" />
                    <div className="SearchTextDivConfigTool">
                        {
                            isDarkTheme ?
                                <img
                                    className="EyeIcon"
                                    src={SearchIcon}
                                    alt="search icon"
                                /> :
                                <img
                                    className="EyeIcon"
                                    src={SearchIconWhite}
                                    alt="search icon" height="15"
                                />
                        }
                    </div>
                </div>
                <div className="StepperSiteList" style={{ height: '40vh' }}>
                    {deviceList.filter(i => (i.Lat == null || i.Lat == 0 || hasDecimalPoint(i.Lat) )).map((device, index) => (
                        <div
                            key={device.DeviceId}
                            className="MapListText"
                            draggable={!editForm || selectedItem == "custom"}
                            onDragStart={(e) => handleDragStartMap(e, device)}
                            style={{ cursor: editForm && selectedItem == "gis_map" ? 'grab' : 'not-allowed' }}
                            // style={{ cursor: 'grab' }}
                        >
                            <div className="DeviceNamesDiv">
                                <img className="EyeIcon" style={{cursor : (!editForm || selectedItem == "custom") && 'not-allowed'}} src={DraggableIcon} alt="drag icon" />
                                <p className="ListofText">{device.Name}</p>
                            </div>
                            {
                                device.isSelected
                                    ? <img className="EyeIcon" style={{cursor : (!editForm || selectedItem == "custom" ) && 'not-allowed'}} src={MapDeviceRemove} alt="search icon" disabled={!editForm} onClick={() => removeMapMarker(device.DeviceId)} />
                                    : null
                            }
                        </div>
                    ))}
                </div>
            </div>
            <div className='Map_Preview'>
                {/* <p className='Map_Preview_text'>Map Preview</p> */}
                
                <APIProvider apiKey={API_KEY}>
                    <div
                        style={{ padding: '0.5rem', width: '100%', height: '100%', position: 'relative' }}
                        onDrop={handleMapDrop}
                        onDragOver={handleDragOver}
                    >
                        <Map
                            key={count}
                            style={{ width: '100%', height: '100%' }}
                            //center={centerPos}
                            defaultCenter={centerPos}
                            // defaultCenter={{ lat: 19.0747045, lng: 72.8869815 }}
                            defaultZoom={15}
                            reuseMaps={true}
                            gestureHandling={'greedy'}
                            zoomControl={editForm}
                            streetViewControl={editForm}
                            fullscreenControl={editForm}
                            disableDoubleClickZoom={!editForm}
                            scrollwheel={editForm}
                            draggableCursor={editForm}

                        // disableDefaultUI={true}
                        >
                            {markerList?.map((item) => (
                                <Marker
                                    key={item.DeviceId}
                                    position={item.position}
                                    onClick={() => setSelectedMarker(item)}
                                    draggable={editForm}
                                    // clickable={editForm}
                                    onDragEnd={(e) => handleMarkerDragEnd(e, item.DeviceId)}
                                    // icon={{
                                    //     url: MapPinIcon,
                                    //     scaledSize: new window.google.maps.Size(50, 50),
                                    // }}
                                    
                                    icon={{
                                        url: MapPinIcon,
                                        scaledSize: window?.google && window?.google?.maps && window?.google?.maps?.Size
                                          ? new window.google.maps.Size(50, 50)
                                          : null,
                                      }}
                                />
                            ))}
                            {selectedMarker && (
                                <InfoWindow
                                    position={selectedMarker.position}
                                    onCloseClick={() => setSelectedMarker(null)}
                                >
                                    <div>
                                        <h4>{selectedMarker.Name}</h4>
                                        <p>Latitude: {selectedMarker.position.lat}</p>
                                        <p>Longitude: {selectedMarker.position.lng}</p>
                                    </div>
                                </InfoWindow>
                            )}

                        </Map>
                    </div>
                </APIProvider>
                
            </div>
        </div>
    )
})

export default GoogleMap